/* Imprime tus PDF (19/10/2026): varios PDF, cada uno con tamaño, color/B-N, caras y copias. Cada PDF se añade al carrito (cart/add.js, el PDF en la propiedad
   «Archivo PDF») como una línea del producto oculto «imprime-tu-pdf» y se va directo a /checkout (con Apple Pay, Google Pay, Shop Pay…), sin pasar por la página
   del carrito. El precio de cada línea sale de la variante (Tipo × Tarifa); la tarifa depende de las caras de TODO el pedido. */
(function () {
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
  var PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

  function $(r, s) { return r.querySelector(s); }
  function eur(c) { return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Informe de fallos a nuestro registro (Worker del portal → panel → Claude): sin nombres de archivo ni datos personales, máx. 6 por visita y sin repetir. */
  var enviados = {}, nInformes = 0;
  function informar(tipo, paso, texto, extra) {
    try {
      var cfg = (window.__ipdfInforme || '');
      if (!cfg || nInformes >= 6) return;
      var k = tipo + '|' + paso + '|' + texto;
      if (enviados[k]) return;
      enviados[k] = 1; nInformes++;
      var b = { tipo: tipo, paso: paso, texto: String(texto || '').slice(0, 200), v: window.__ipdfVersion || '' };
      if (extra && extra.mb != null) b.mb = extra.mb;
      fetch(cfg, { method: 'POST', mode: 'no-cors', keepalive: true, body: JSON.stringify(b) }).catch(function () {});
    } catch (e) {}
  }
  window.addEventListener('error', function (e) {
    if (e && e.filename && /imprime-pdf/.test(e.filename)) informar('error', 'js', (e.message || 'error') + ' @' + (e.lineno || 0));
  });
  window.addEventListener('unhandledrejection', function (e) {
    var t = e && e.reason && (e.reason.message || e.reason);
    if (t && /imprime-pdf|pdf/i.test(String(e.reason && e.reason.stack || t))) informar('error', 'promesa', String(t).slice(0, 150));
  });

  var pdfjsP = null;
  function cargarPdfjs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfjsP) return pdfjsP;
    pdfjsP = new Promise(function (ok, no) {
      var s = document.createElement('script');
      s.src = PDFJS;
      s.onload = function () { try { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER; ok(window.pdfjsLib); } catch (e) { no(e); } };
      s.onerror = function () { pdfjsP = null; no(new Error('pdfjs')); };
      document.head.appendChild(s);
    });
    return pdfjsP;
  }
  function tamanoPapel(wPt, hPt) {
    var a = wPt * 25.4 / 72, b = hPt * 25.4 / 72, c = Math.min(a, b), l = Math.max(a, b);
    if (Math.abs(c - 210) <= 6 && Math.abs(l - 297) <= 6) return 'A4';
    if (Math.abs(c - 297) <= 8 && Math.abs(l - 420) <= 8) return 'A3';
    return null;
  }
  function leer(f, tipo) {
    return new Promise(function (ok, no) { var fr = new FileReader(); fr.onload = function () { ok(fr.result); }; fr.onerror = no; fr.readAsArrayBuffer(f); });
  }

  /* última elección de color y caras, para los PDF siguientes (y la próxima visita) */
  function leePref() {
    try { var p = JSON.parse(localStorage.getItem('ipdf_pref') || '{}'); return { color: p.color === 'CO' ? 'CO' : 'BN', caras: p.caras === 2 ? 2 : 1 }; } catch (e) { return { color: 'BN', caras: 1 }; }
  }
  function guardaPref(it) { try { localStorage.setItem('ipdf_pref', JSON.stringify({ color: it.color, caras: it.caras })); } catch (e) {} }

  function App(r) {
    var self = this;
    this.r = r; this.cfg = JSON.parse($(r, '[data-ipdf-config]').textContent);
    window.__ipdfInforme = this.cfg.informe || ''; window.__ipdfVersion = this.cfg.version || '';
    this.items = []; this.nId = 0; this.busy = false;
    this.input = $(r, '[data-ipdf-input]'); this.drop = $(r, '[data-ipdf-drop]'); this.lista = $(r, '[data-ipdf-lista]');
    this.resumen = $(r, '[data-ipdf-resumen]'); this.btn = $(r, '[data-ipdf-pagar]');
    this.drop.addEventListener('click', function () { self.input.click(); });
    this.input.addEventListener('change', function () { self.anadir([].slice.call(self.input.files)); self.input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.remove('is-over'); }); });
    this.drop.addEventListener('drop', function (e) { self.anadir([].slice.call((e.dataTransfer && e.dataTransfer.files) || [])); });
    this.lista.addEventListener('click', function (e) { self.clic(e); });
    /* Mantener pulsado + o −: las copias corren (cada vez más deprisa) sin redibujar la lista */
    var rep = null;
    function parar() { if (rep) { clearTimeout(rep.t); rep = null; } }
    this.lista.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('button[data-mas],button[data-menos]'); if (!b) return;
      var it = self.item(b); if (!it) return;
      var dir = b.hasAttribute('data-mas') ? 1 : -1, paso = 0;
      parar(); self.repetido = false; rep = { t: 0, usado: false };
      var r = rep;
      (function vuelta(espera) {
        r.t = setTimeout(function () {
          if (rep !== r) return;
          r.usado = true; paso++;
          var n = Math.max(1, Math.min(999, it.copias + dir * (paso > 25 ? 5 : 1)));
          it.copias = n;
          var inp = b.parentNode.querySelector('input[data-copias]'); if (inp) inp.value = n;
          self.precios();
          vuelta(paso > 25 ? 50 : paso > 8 ? 80 : 130);
        }, espera);
      })(450);
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { document.addEventListener(ev, function () { var u = rep && rep.usado; parar(); if (u) self.repetido = true; }); });
    this.lista.addEventListener('contextmenu', function (e) { if (e.target.closest('button[data-mas],button[data-menos]')) e.preventDefault(); });
    this.lista.addEventListener('input', function (e) {
      var inp = e.target.closest('input[data-copias]'); if (!inp) return;
      var it = self.item(inp); var n = parseInt(inp.value, 10); if (it && n >= 1) { it.copias = Math.min(999, n); self.precios(); }
    });
    this.lista.addEventListener('change', function (e) {
      var inp = e.target.closest('input[data-copias]'); if (!inp) return;
      var it = self.item(inp); if (it) { it.copias = Math.max(1, Math.min(999, parseInt(inp.value, 10) || 1)); inp.value = it.copias; self.precios(); }
    });
    this.btn.addEventListener('click', function () { self.pagar(); });
    this.fija = document.querySelector('[data-ipdf-fija]');
    this.igual = $(r, '[data-ipdf-igual]');
    this.igual.addEventListener('click', function () {
      var l = self.items.filter(function (i) { return i.estado === 'listo'; }), a = l[0];
      l.forEach(function (i) { i.color = a.color; i.caras = a.caras; i.tam = a.tam; i.copias = a.copias; });
      self.pinta();
    });
    if (this.fija) {
      this.fija.querySelector('[data-ipdf-fija-btn]').addEventListener('click', function () { self.pagar(); });
      if (window.IntersectionObserver) new IntersectionObserver(function (es) { self.resumenVisible = es[0].isIntersecting; self.fijaEstado(); }, { threshold: 0.2 }).observe(this.btn);
    }
    if (!this.cfg.variantes.length) this.error('Esta página no está disponible ahora mismo. Escríbenos por WhatsApp y te lo imprimimos igual.');
    this.pinta();
  }

  App.prototype.fijaEstado = function () {
    if (!this.fija) return;
    var c = this.calculo(), hay = c.listos.length > 0 && this.items.every(function (i) { return i.estado === 'listo'; });
    this.fija.classList.toggle('is-on', hay && !this.resumenVisible);
    this.fija.hidden = false;
    $(this.fija, '[data-ipdf-fija-total]').textContent = hay ? eur(c.total) : '';
    var b = $(this.fija, '[data-ipdf-fija-btn]'); b.disabled = this.busy || !c.ok; if (!this.busy) b.textContent = 'Pagar';
  };

  App.prototype.error = function (t) { var e = $(this.r, '[data-ipdf-error]'); if (!t) { e.hidden = true; return; } e.textContent = t; e.hidden = false; };
  App.prototype.item = function (el) { var id = el.closest('[data-id]'); id = id && +id.getAttribute('data-id'); return this.items.filter(function (i) { return i.id === id; })[0]; };

  App.prototype.anadir = function (archivos) {
    var self = this; this.error('');
    archivos.forEach(function (f) {
      if (self.items.length >= self.cfg.maxPdf) return self.error('Máximo ' + self.cfg.maxPdf + ' PDF por pedido. Haz dos pedidos o escríbenos.');
      if (!/\.pdf$/i.test(f.name) && f.type !== 'application/pdf') { informar('aviso', 'elegir', 'no es un PDF (extensión/tipo)'); return self.error(f.name + ' no es un PDF. Solo se pueden enviar PDF: expórtalo a PDF primero.'); }
      if (f.size > self.cfg.maxMb * 1048576) { informar('aviso', 'elegir', 'pesa más del límite', { mb: f.size / 1048576 }); return self.error(f.name + ' pesa más de ' + self.cfg.maxMb + ' MB. Mándanoslo por WhatsApp y te lo imprimimos igual.'); }
      if (!f.size) return self.error(f.name + ' está vacío.');
      var pref = leePref(), it = { id: ++self.nId, file: f, estado: 'leyendo', paginas: 0, tam: 'A4', color: pref.color, caras: pref.caras, copias: 1, aviso: '', thumb: null };
      self.items.push(it); self.leerPdf(it);
    });
    this.pinta();
  };

  App.prototype.leerPdf = function (it) {
    var self = this, f = it.file;
    leer(f.slice(0, 1024)).then(function (b) {
      if (String.fromCharCode.apply(null, new Uint8Array(b)).indexOf('%PDF') < 0) throw { tipo: 'nopdf' };
      return leer(f);
    }).then(function (buf) {
      return cargarPdfjs().then(function (lib) { return lib.getDocument({ data: buf }).promise; });
    }).then(function (doc) {
      var n = doc.numPages, tamanos = {}, primero = null, lim = Math.min(n, 40), i = 1;
      function paso() {
        if (i > lim) return Promise.resolve();
        return doc.getPage(i).then(function (p) {
          var v = p.getViewport({ scale: 1 }), k = tamanoPapel(v.width, v.height) || (Math.round(Math.min(v.width, v.height) * 25.4 / 72) + ' × ' + Math.round(Math.max(v.width, v.height) * 25.4 / 72) + ' mm');
          tamanos[k] = (tamanos[k] || 0) + 1; if (!primero) primero = k;
          if (i === 1) {
            var esc2 = 160 / Math.max(v.width, v.height), vv = p.getViewport({ scale: esc2 * 2 }), c = document.createElement('canvas');
            c.width = vv.width; c.height = vv.height;
            return p.render({ canvasContext: c.getContext('2d'), viewport: vv }).promise.then(function () { it.thumb = c; }, function () {});
          }
        }).then(function () { i++; return paso(); });
      }
      return paso().then(function () {
        it.paginas = n; it.estado = 'listo'; self.subirFondo(it);
        var claves = Object.keys(tamanos);
        if (primero === 'A4' || primero === 'A3') it.tam = primero;
        if (primero !== 'A4' && primero !== 'A3') it.aviso = 'Este PDF mide ' + primero + ': se imprimirá ajustado al tamaño que elijas, sin deformarlo.';
        else if (claves.length > 1) it.aviso = 'Este PDF mezcla tamaños de página (' + claves.join(', ') + '): se imprimirá todo en ' + it.tam + ', ajustando cada página.';
        if (doc.destroy) doc.destroy();
      });
    }).catch(function (e) {
      self.items = self.items.filter(function (x) { return x !== it; });
      if (e && e.tipo === 'nopdf') { informar('aviso', 'leer', 'no parece un PDF (cabecera)'); self.error(f.name + ' no parece un PDF de verdad. Ábrelo y usa «Guardar como PDF».'); }
      else if (e && e.name === 'PasswordException') { informar('aviso', 'leer', 'PDF con contraseña'); self.error(f.name + ' tiene contraseña. Quítasela y vuelve a subirlo.'); }
      else if (e && e.message === 'pdfjs') { informar('error', 'leer', 'no carga pdf.js (cdnjs bloqueado o sin red)'); self.error('No hemos podido leer el PDF ahora mismo. Recarga la página o escríbenos por WhatsApp.'); }
      else { informar('error', 'leer', 'no se puede leer el PDF: ' + String(e && (e.message || e.name || e)).slice(0, 120), { mb: f.size / 1048576 }); self.error('No hemos podido leer ' + f.name + '. ¿Está dañado? Prueba a guardarlo de nuevo como PDF.'); }
    }).then(function () { self.pinta(); });
  };

  /* SUBIDA EN SEGUNDO PLANO: el PDF sube al Worker de presupuestos (/archivo → Shopify Files) mientras el cliente elige opciones; al pagar solo se manda su
     enlace. Si el Worker no responde (o no hay), se sube junto con el carrito como antes. */
  App.prototype.subirFondo = function (it) {
    var self = this, w = this.cfg.worker;
    if (!w) { it.sub = 'directo'; return; }
    it.sub = 'subiendo'; it.pct = 0;
    var fd = new FormData(); fd.append('archivo', it.file, it.file.name);
    var url = w.replace(/\/+$/, '') + '/archivo';
    var envio = window.Cargando ? Cargando.subir(url, fd, function (p) { it.pct = Math.round(p); self.progreso(it); })
      : fetch(url, { method: 'POST', body: fd }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
    envio.then(function (res) {
      if (res.ok && res.json && res.json.url) { it.url = res.json.url; it.sub = 'ok'; } else it.sub = 'error';
    }, function () { it.sub = 'error'; informar('aviso', 'subida-fondo', 'falla la subida en segundo plano (red o Worker)', { mb: it.file.size / 1048576 }); }).then(function () { if (it.sub === 'error') informar('aviso', 'subida-fondo', 'la subida en segundo plano devuelve error'); self.progreso(it); });
    this.progreso(it);
  };
  App.prototype.progreso = function (it) {
    var el = this.lista.querySelector('[data-id="' + it.id + '"] [data-sub]'); if (!el) return;
    if (it.sub === 'subiendo') el.innerHTML = it.pct >= 100 ? 'Guardando tu PDF…' : 'Subiendo tu PDF… ' + (it.pct || 0) + ' %';
    else if (it.sub === 'ok') el.innerHTML = '<b>✓ PDF subido</b>';
    else el.textContent = '';
    el.classList.toggle('is-ok', it.sub === 'ok');
    el.style.setProperty('--p', (it.sub === 'subiendo' ? it.pct : it.sub === 'ok' ? 100 : 0) + '%');
  };
  App.prototype.esperarSubidas = function () {
    var self = this;
    return new Promise(function (ok) {
      (function mira() { if (self.items.some(function (i) { return i.sub === 'subiendo'; })) setTimeout(mira, 250); else ok(); })();
    });
  };

  App.prototype.clic = function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (this.repetido && (b.hasAttribute('data-mas') || b.hasAttribute('data-menos'))) { this.repetido = false; return; }
    var it = this.item(b); if (!it) return;
    if (b.hasAttribute('data-quitar')) { this.items = this.items.filter(function (x) { return x !== it; }); this.pinta(); return; }
    if (b.hasAttribute('data-tam')) it.tam = b.getAttribute('data-tam');
    else if (b.hasAttribute('data-color')) { it.color = b.getAttribute('data-color'); guardaPref(it); }
    else if (b.hasAttribute('data-caras')) { it.caras = +b.getAttribute('data-caras'); guardaPref(it); }
    else if (b.hasAttribute('data-menos')) it.copias = Math.max(1, it.copias - 1);
    else if (b.hasAttribute('data-mas')) it.copias = Math.min(999, it.copias + 1);
    else return;
    this.pinta();
  };

  App.prototype.nombreTipo = function (it) {
    return it.tam + ' · ' + (it.color === 'CO' ? 'Color' : 'Blanco y negro') + ' · ' + (it.caras === 2 ? 'Doble cara (hoja)' : 'Una cara');
  };
  App.prototype.variante = function (it, tarifa) {
    var tipo = this.nombreTipo(it), r = null;
    this.cfg.variantes.forEach(function (v) { if (v.tipo === tipo && v.tarifa === tarifa) r = v; });
    return r;
  };
  /* tarifa según las caras de TODO el pedido; unidades por línea: caras (una cara) u hojas (doble cara, por copia) */
  App.prototype.calculo = function () {
    var self = this, cfg = this.cfg, listos = this.items.filter(function (i) { return i.estado === 'listo'; }), caras = 0, sub = 0, ok = true;
    listos.forEach(function (i) { i.nCaras = i.paginas * i.copias; caras += i.nCaras; });
    var tarifa = cfg.tramos[0];
    cfg.tramos.forEach(function (t) { if (caras >= t.desde) tarifa = t; });
    listos.forEach(function (i) {
      i.v = self.variante(i, tarifa.nombre); i.extra = 0;
      if (!i.v) { ok = false; i.units = 0; i.centimos = 0; return; }
      i.units = i.caras === 2 ? Math.ceil(i.paginas / 2) * i.copias : i.nCaras;
      i.centimos = i.units * i.v.precio; sub += i.centimos;
    });
    var ajuste = 0;
    if (ok && listos.length && sub < cfg.minimo) {   // pedido mínimo: se sube la cantidad de la primera línea hasta llegar
      var l0 = listos[0], falta = cfg.minimo - sub, extra = Math.ceil(falta / l0.v.precio);
      l0.extra = extra; l0.units += extra; ajuste = extra * l0.v.precio; l0.centimos += ajuste; sub += ajuste;
    }
    var pct = 0, ahorro = 0;
    listos.forEach(function (i) {
      var b = self.variante(i, cfg.tramos[0].nombre);
      if (!i.v || !b) return;
      pct = Math.max(pct, Math.round((1 - i.v.precio / b.precio) * 100));
      ahorro += (i.units - i.extra) * (b.precio - i.v.precio);
    });
    return { listos: listos, caras: caras, pct: pct, ahorro: ahorro, sub: sub, ajuste: ajuste, total: sub, ok: ok, tarifa: tarifa };
  };

  App.prototype.pinta = function () {
    var self = this, lista = this.lista;
    this.r.classList.toggle('tiene', this.items.length > 0);
    $(this.r, '[data-ipdf-drop-titulo]').textContent = this.items.length ? 'Añadir más PDF' : 'Suelta aquí tus PDF o pulsa para elegirlos';
    var html = '';
    this.items.forEach(function (it) {
      var listo = it.estado === 'listo';
      html += '<article class="ipdf__ficha" data-id="' + it.id + '"><div class="ipdf__mini" data-mini>' + (listo ? '' : '…') + '</div><div class="ipdf__cuerpo">' +
        '<div class="ipdf__cab"><div style="min-width:0"><p class="ipdf__nombre" title="' + esc(it.file.name) + '">' + esc(it.file.name) + '</p>' +
        '<p class="ipdf__datos">' + (listo ? it.paginas + (it.paginas === 1 ? ' página' : ' páginas') + ' · ' + (it.file.size < 1048576 ? Math.max(1, Math.round(it.file.size / 1024)) + ' KB' : (it.file.size / 1048576).toFixed(1) + ' MB') : 'Leyendo el PDF…') + '</p></div>' +
        '<button type="button" class="ipdf__quitar" data-quitar aria-label="Quitar ' + esc(it.file.name) + '">×</button></div>';
      if (listo) {
        if (it.aviso) html += '<p class="ipdf__aviso">' + esc(it.aviso) + '</p>';
        html += '<div class="ipdf__fila"><div class="ipdf__seg" role="group" aria-label="Tamaño"><button type="button" data-tam="A4" class="' + (it.tam === 'A4' ? 'is-on' : '') + '">A4</button><button type="button" data-tam="A3" class="' + (it.tam === 'A3' ? 'is-on' : '') + '">A3</button></div>' +
          '<div class="ipdf__seg ipdf__seg--color" role="group" aria-label="Color"><button type="button" data-color="BN" class="' + (it.color === 'BN' ? 'is-on' : '') + '">Blanco y negro</button><button type="button" data-color="CO" class="' + (it.color === 'CO' ? 'is-on' : '') + '">Color</button></div>' +
          '<div class="ipdf__seg" role="group" aria-label="Caras"><button type="button" data-caras="1" class="' + (it.caras === 1 ? 'is-on' : '') + '">Una cara</button><button type="button" data-caras="2" class="' + (it.caras === 2 ? 'is-on' : '') + '">Doble cara</button></div></div>' +
          '<div class="ipdf__fila"><span class="ipdf__etq">Copias</span><div class="ipdf__cant"><button type="button" data-menos aria-label="Una copia menos">−</button><input type="number" inputmode="numeric" min="1" max="999" value="' + it.copias + '" data-copias aria-label="Copias de ' + esc(it.file.name) + '"><button type="button" data-mas aria-label="Una copia más">+</button></div>' +
          '<span class="ipdf__importe" data-importe></span></div><p class="ipdf__subida" data-sub></p>';
      }
      html += '</div></article>';
    });
    lista.innerHTML = html;
    this.items.forEach(function (it) { self.progreso(it); });
    this.items.forEach(function (it) {
      if (it.thumb) { var m = lista.querySelector('[data-id="' + it.id + '"] [data-mini]'); if (m) { m.textContent = ''; m.appendChild(it.thumb); } }
    });
    this.precios();
  };

  App.prototype.precios = function () {
    var self = this, c = this.calculo(), cfg = this.cfg;
    c.listos.forEach(function (it) {
      var el = self.lista.querySelector('[data-id="' + it.id + '"] [data-importe]');
      if (el) el.innerHTML = eur(it.centimos) + '<small>' + it.nCaras + (it.nCaras === 1 ? ' cara' : ' caras') + (it.caras === 2 ? ' · ' + Math.ceil(it.paginas / 2) * it.copias + ' hojas' : '') + '</small>';
    });
    if (!c.listos.length) { this.resumen.hidden = true; this.fijaEstado(); return; }
    this.resumen.hidden = false;
    this.igual.hidden = c.listos.length < 2;
    var sig = null; cfg.tramos.forEach(function (t) { if (!sig && c.caras < t.desde) sig = t; });
    var hayDto = c.listos.some(function (i) { var a = self.variante(i, cfg.tramos[0].nombre), z = self.variante(i, cfg.tramos[cfg.tramos.length - 1].nombre); return a && z && z.precio < a.precio; });
    if (!hayDto) sig = null;
    var ant = 0; cfg.tramos.forEach(function (t) { if (c.caras >= t.desde) ant = t.desde; });
    var tr = $(this.resumen, '[data-ipdf-tramo]');
    function pctSig(t) {   // la mayor bajada de precio que tendrían los PDF del pedido en la tarifa t
      var m = 0;
      c.listos.forEach(function (i) { var a = self.variante(i, cfg.tramos[0].nombre), b2 = self.variante(i, t.nombre); if (a && b2) m = Math.max(m, Math.round((1 - b2.precio / a.precio) * 100)); });
      return m;
    }
    if (sig) {
      var prog = Math.min(100, Math.round((c.caras - ant) / (sig.desde - ant) * 100)), ps = pctSig(sig);
      tr.innerHTML = '<div><b>' + c.caras + ' ' + (c.caras === 1 ? 'cara' : 'caras') + '</b>' + (c.ahorro ? ' · ya ahorras <b>' + eur(c.ahorro) + '</b> por cantidad' : '') + '. Con <b>' + sig.desde + ' caras</b> todo el pedido baja de precio, hasta un <b>−' + ps + ' %</b> (te faltan ' + (sig.desde - c.caras) + ').</div><div class="ipdf__barra"><span style="width:' + prog + '%"></span></div>';
    } else tr.innerHTML = '<div><b>' + c.caras + (c.caras === 1 ? ' cara' : ' caras') + '</b>' + (hayDto ? ' · tienes el mejor precio' + (c.ahorro ? ': ahorras <b>' + eur(c.ahorro) + '</b> por cantidad' : '') : '') + '.</div>';
    var d = '<div><dt>Impresión (' + c.listos.length + ' PDF, ' + c.caras + ' caras)</dt><dd>' + eur(c.sub - c.ajuste) + '</dd></div>';
    if (c.ahorro) d += '<div><dt>Ahorro por cantidad (ya incluido)</dt><dd>−' + eur(c.ahorro) + '</dd></div>';
    if (c.ajuste) d += '<div><dt>Ajuste al pedido mínimo (' + eur(cfg.minimo) + ')</dt><dd>' + eur(c.ajuste) + '</dd></div>';
    d += '<div class="ipdf__total"><dt>Total (IVA incl.)</dt><dd>' + eur(c.total) + '</dd></div>';
    $(this.resumen, '[data-ipdf-desglose]').innerHTML = d;
    if (!c.ok && c.listos.length) informar('error', 'precio', 'sin variante para ' + c.listos.map(function (i) { return i.tam + '/' + i.color + '/' + i.caras; }).join(','));
    var todos = this.items.every(function (i) { return i.estado === 'listo'; });
    if (!this.busy) { this.btn.disabled = !todos || !c.ok; this.btn.textContent = todos ? 'Pagar · ' + eur(c.total) : 'Leyendo tus PDF…'; }
    this.fijaEstado();
  };

  App.prototype.pagar = function () {
    var self = this, c = this.calculo();
    if (!c.listos.length || this.busy || !c.ok) return;
    this.busy = true; this.btn.disabled = true; this.error('');
    var txt = 'Subiendo tus PDF';
    if (window.Cargando) Cargando.ocupar(this.btn, txt + '…', true); else this.btn.textContent = txt + '…';
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var total = c.listos.reduce(function (s, i) { return s + (i.url ? 0 : i.file.size); }, 0) || 1, hechos = 0, claves = [];
    function subir(i) {
      if (i >= c.listos.length) return Promise.resolve();
      var it = c.listos[i], fd = new FormData();
      fd.append('id', it.v.id); fd.append('quantity', it.units);
      if (it.url) fd.append('properties[Archivo PDF]', it.url); else fd.append('properties[Archivo PDF]', it.file, it.file.name);
      if (it.file.name) fd.append('properties[Nombre del archivo]', it.file.name.slice(0, 80));
      fd.append('properties[Tamaño]', it.tam);
      fd.append('properties[Color]', it.color === 'CO' ? 'Color' : 'Blanco y negro');
      fd.append('properties[Caras]', it.caras === 2 ? 'Doble cara' : 'Una cara');
      fd.append('properties[Páginas]', it.paginas);
      fd.append('properties[Copias]', it.copias);
      fd.append('properties[Caras a imprimir]', it.nCaras);
      fd.append('properties[Hojas]', it.caras === 2 ? Math.ceil(it.paginas / 2) * it.copias : it.nCaras);
      if (it.extra) fd.append('properties[Pedido mínimo]', 'Se cobra un mínimo de ' + eur(self.cfg.minimo) + ': imprimir solo las ' + it.nCaras + ' caras');
      fd.append('properties[_libre]', it.units);
      var url = raiz + 'cart/add.js', cb = function (p) {
        var pc = Math.min(100, (hechos + (it.url ? 0 : it.file.size) * p / 100) / total * 100);
        if (window.Cargando) { if (pc >= 100) Cargando.ocupar(self.btn, 'Preparando tu pago…'); else Cargando.pct(self.btn, pc, txt); }
      };
      var envio = window.Cargando ? Cargando.subir(url, fd, cb) : fetch(url, { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); });
      return envio.then(function (res) {
        if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'carrito');
        if (res.json && res.json.key) claves.push(res.json.key);
        hechos += it.url ? 0 : it.file.size;
        return subir(i + 1);
      });
    }
    var pendientes = this.items.some(function (i) { return i.sub === 'subiendo'; });
    if (pendientes) { if (window.Cargando) Cargando.ocupar(self.btn, 'Terminando de subir tus PDF…'); else this.btn.textContent = 'Terminando de subir tus PDF…'; }
    this.esperarSubidas().then(function () { c = self.calculo(); return subir(0); }).then(function () {
      if (window.Cargando) Cargando.ocupar(self.btn, 'Vamos al pago…');
      window.location.href = raiz + 'checkout';
    }).catch(function (e) {
      var deshacer = claves.length ? fetch(raiz + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: claves.reduce(function (o, k) { o[k] = 0; return o; }, {}) }) }).catch(function () {}) : Promise.resolve();
      deshacer.then(function () {
        self.busy = false;
        if (window.Cargando && Cargando.libre) Cargando.libre(self.btn);
        informar('error', 'pagar', 'cart/add falla: ' + String(e && e.message || e).slice(0, 150));
        self.error('No se ha podido preparar el pago. Inténtalo otra vez o escríbenos por WhatsApp.' + (e && e.message && e.message !== 'carrito' && e.message !== 'red' ? ' (' + e.message + ')' : ''));
        self.precios();
      });
    });
  };

  function init() { document.querySelectorAll('[data-imprime-pdf]').forEach(function (el) { if (!el._ipdf) el._ipdf = new App(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
